import React, { useEffect, useState } from "react";
import { objectToArray } from "../misc/helperfuncs";

const DetailedPointsBar = ({ points }) => {
  const [pointsArray, setPointsArray] = useState([]);

  useEffect(() => {
    setPointsArray(objectToArray(points));
  }, []);

  return (
    <div
      className="divRow"
      style={{
        width: "90%",
        position: "relative",
        borderRadius: ".5rem/.5rem",

        padding: "5px",
      }}
    >
      <div className="divRow" style={{ zIndex: 2, marginLeft: "5px" }}>
        <img src="/icons/icon_point.png" className="icon25" />
        <div className="textBoldWhite">Points</div>
      </div>
      <div
        className="divRow"
        style={{ flex: 1, justifyContent: "space-around" }}
      >
        {pointsArray.map((kv) => (
          <PointHolder kv={kv} key={kv.key} />
        ))}
      </div>
      <div
        style={{
          zIndex: 1,
          borderRadius: ".5rem/.5rem",
          width: "100%",
          height: "100%",
          position: "absolute",
          backgroundColor: "#2f2f2f",
          border: "4px solid #1f1f1f",
          opacity: 0.8,
        }}
      />
    </div>
  );
};

const PointHolder = ({ kv }) => {
  return (
    <div className="divColumn" style={{ zIndex: 2 }}>
      <div className="textWhite" style={{ fontSize: "13px" }}>
        {kv.key}
      </div>
      <div
        className="textBoldWhite"
        style={{
          backgroundColor: "#6f6f6f",
          padding: "2px",
          paddingLeft: "5px",
          paddingRight: "5px",
          borderRadius: ".5rem/.5rem",
        }}
      >
        {kv.value}
      </div>
    </div>
  );
};

export default DetailedPointsBar;
